/**
 * Breadcrumb Enricher Middleware
 * Attaches recent breadcrumbs to error events
 */

import type { Middleware, CollectedEvent } from '../types.js';
import type { BreadcrumbManager } from '../../utils/session.js';

export class BreadcrumbEnricher implements Middleware {
  name = 'breadcrumb-enricher';
  private breadcrumbManager: BreadcrumbManager;

  constructor(breadcrumbManager: BreadcrumbManager) {
    this.breadcrumbManager = breadcrumbManager;
  }

  onPostCollect(event: CollectedEvent): CollectedEvent {
    // Only enrich error events
    if (event.event_category === 'error') {
      // Get all breadcrumbs and attach as JSON
      const breadcrumbs = this.breadcrumbManager.getAll();
      
      return {
        ...event,
        breadcrumbs_json: JSON.stringify(breadcrumbs)
      };
    }

    return event;
  }
}

